<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Code</mat-label>
                    <input matInput data-input-code type="text" formControlName="code" autocomplete="off" required />
                    @if (formGroupErrors?.code?.required && (formGroup.controls['code']?.dirty || formGroup.controls['code'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Code' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Type" matTooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Designation 1</mat-label>
                    <input matInput data-input-designation1 type="text" formControlName="designation1" autocomplete="off" required />
                    @if (formGroupErrors?.designation1?.required && (formGroup.controls['designation1']?.dirty || formGroup.controls['designation1'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Designation1' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Désignation" matTooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Designation 2</mat-label>
                    <input matInput data-input-designation2 type="text" placeholder="Designation 2" formControlName="designation2" autocomplete="off" />
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Désignation 2" matTooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Prix unitaire</mat-label>
                    <input matInput data-input-unitPrice type="text" formControlName="unitPrice" autocomplete="off" />
                    @if (formGroupErrors?.unitPrice?.pattern && (formGroup.controls['unitPrice']?.dirty || formGroup.controls['unitPrice'].touched)) {
                        <mat-error data-input-unitPrice-error>Le champ 'Prix unitaire' est incorrect</mat-error>
                    }
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Prix unitaire" matTooltipPosition="right"></fa-icon>
            </div>
        </div>
    </form>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="formGroup.disabled" [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }" (click)="cancel()">
            Annuler
        </button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }"
            (click)="manualSave()">
            Enregistrer
        </button>
    </div>
</div>
